var React = require('react');

function FourPointStar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M134 1.18227L176.185 91.5729L176.262 91.7377L176.427 91.8146L266.818 134L176.427 176.185L176.262 176.262L176.185 176.427L134 266.818L91.8146 176.427L91.7377 176.262L91.5729 176.185L1.18227 134L91.5729 91.8146L91.7377 91.7377L91.8146 91.5729L134 1.18227Z","stroke":"#3E4F19"}));
}

FourPointStar.defaultProps = {"width":"268","height":"268","viewBox":"0 0 268 268","fill":"none"};

module.exports = FourPointStar;

FourPointStar.default = FourPointStar;
